import React, { useEffect } from 'react';
import { Button, Form, message } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useLayoutContext } from '../../../Layout/context';
import useUnsavedChanges from '../../../../hooks/unsavedChanges';
import Content from '../../../Common/Content';
import PageForm from '../Form';
import { useMessageError } from '../../../../hooks/common';
import { useInternationalCreate } from '../../../../hooks/api/internationals';

import styles from './index.module.scss';

export default function PageCreate(): JSX.Element {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { setBreadcrumbs } = useLayoutContext();
  const internationalCreate = useInternationalCreate();
  const { setInitData, check, setChanged, contextHolder, isChanged } = useUnsavedChanges();

  useMessageError([internationalCreate]);

  useEffect(() => {
    setBreadcrumbs([
      { title: 'Tipping internationals', href: '/internationals' },
      { title: 'Create international page' },
    ]);
  }, []);

  useEffect(() => {
    if (internationalCreate.data && !internationalCreate.error && !internationalCreate.loading) {
      message.success('International page create successfully');
      navigate('/internationals');
    }
  }, [internationalCreate.data, internationalCreate.loading]);

  return (
    <>
      <div className={styles.header}>
        <h2>Create international page</h2>
        <div className={styles.actions}>
          <Button
            onClick={(e) => {
              e.preventDefault();
              navigate('/internationals');
              window.location.reload();
            }}
          >
            Cancel
          </Button>
          <Button
            icon={<SaveOutlined />}
            type="primary"
            onClick={() => {
              form.submit();
            }}
            disabled={!isChanged}
          >
            Save Changes
          </Button>
        </div>
      </div>

      <Content className={styles.content}>
        <Form
          layout="vertical"
          className={styles.main}
          form={form}
          onFinish={(data) => {
            setInitData(data);

            const { categoryId: category, ...values } = data;

            internationalCreate.fetch({
              ...values,
              categoryId: typeof category === 'object' ? category.value : category,
            });
          }}
          onChange={() => setChanged(check(form.getFieldsValue()))}
        >
          <PageForm form={form} onChange={() => setChanged(check(form.getFieldsValue()))} />
        </Form>
      </Content>

      {contextHolder}
    </>
  );
}
